// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { CompUnit_abstract } from './../abstract/SagaSchema/CompUnit_abstract';
export class CompUnit extends CompUnit_abstract {}
